import React, { useState } from "react";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import OnBoardingBtn from "../../../components/OnBoardingBtn/OnBoardingBtn";
import useOnboarding from "../../../hooks/useOnboarding";
import { TOUR_STEPS } from "../../../utils/tour";

const Tour = () => {
   const { width } = useWindowDimensions();
   const isTablet = width < 1000;

   const tourSteps = isTablet ? TOUR_STEPS.dashboard.mobile : TOUR_STEPS.dashboard.desktop

   const [runOnboarding, setRunOnboarding] = useState(false)
   const tour = useOnboarding({
      steps: tourSteps,
      page: 'dashboard',
      runAgain: runOnboarding,
      lastBtnFunction: () => setRunOnboarding(false)
   });

   return (
      <>
         <OnBoardingBtn onClick={() => setRunOnboarding(true)} />
         {tour}
      </>
   );
}

export default Tour; 